import {css, CSSProperties, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_DARK} from 'ui-library/Colors';

import {dataFrameTableStyles} from './DataFrameTable';

export interface DataFrameTableIndexCellProps {
  index: number;
  minWidth: CSSProperties['minWidth'];
  showCheckbox: boolean;
  isCheckboxSelected: boolean;
}

function DataFrameTableIndexCellContents(props: DataFrameTableIndexCellProps): JSX.Element {
  return (
    <div style={{minWidth: props.minWidth}}>
      {props.showCheckbox ? (
        <input
          className={css(dataFrameTableStyles.checkbox)}
          checked={props.isCheckboxSelected}
          readOnly={true}
          type="checkbox"
        />
      ) : (
        <span className={css(styles.indexCell)}>{props.index}</span>
      )}
    </div>
  );
}

export default React.memo(DataFrameTableIndexCellContents);

const styles = StyleSheet.create({
  indexCell: {
    color: GRAY_DARK,
  },
});
